<template>
  <panel>
    <metric :title="title" :metric="metric" :type="type" :tooltip="tooltip" />
  </panel>
</template>

<script>
import Panel from '@/common/components/Panel'
import Metric from '@/common/components/Metric'
export default {
  name: 'KeyMetric',
  components: { Metric, Panel },
  props: {
    title: {
      type: String,
      required: true
    },
    metric: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      required: false
    },
    tooltip: {
      type: String,
      required: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/KeyMetric.vue